module.exports = __webpack_public_path__ + "img/bottom_people_003.28d5f863.svg";